var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 13C12.3333 12.0696 12.3333 11.6044 12.2185 11.2259C11.96 10.3736 11.293 9.70669 10.4408 9.44816C10.0622 9.33333 9.59703 9.33333 8.66665 9.33333H5.33333C4.40295 9.33333 3.93776 9.33333 3.55923 9.44816C2.70696 9.70669 2.04002 10.3736 1.78148 11.2259C1.66666 11.6044 1.66666 12.0696 1.66666 13M9.99999 4C9.99999 5.65685 8.65684 7 6.99999 7C5.34314 7 3.99999 5.65685 3.99999 4C3.99999 2.34315 5.34314 1 6.99999 1C8.65684 1 9.99999 2.34315 9.99999 4Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.2e1dea914e2c75e87a2d452f6134f118.svg";
export { ForwardRef as ReactComponent };